import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { extractStylesToArray, isSafe } from "@insite/client-framework/Common/Utilities/isSafeStyles";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { IconPresentationProps } from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@tecumseh/theme/design";
import parse from "html-react-parser";
import * as React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";

const enum fields {
    bannerType= "bannerType",
    content = "content",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.bannerType]: string;
        [fields.content]: string;
    };
}

export interface AlertBannerStyles {
    wrapper?: InjectableCss;
    buttonWrapper?: InjectableCss;
    closeButtonIconProps?: IconPresentationProps;
}

const alertBannerStyles: AlertBannerStyles = {
    wrapper: {
        css: css`
            float: left;
            padding: 14px;
            width: 90%;
        `
    },
    buttonWrapper: {
        css: css`
            float: right;
            margin: 12px 18px;
            cursor: pointer;
            top: 0;
            right: 0;
            position: absolute;
        `
    },
};

const mapStateToProps = (state: ApplicationState) => {
    return {
        page: getCurrentPage(state),
    }
}
const styles = alertBannerStyles;
type Props = OwnProps & ReturnType<typeof mapStateToProps>;
const AlertBanner: React.FunctionComponent<Props> = ({ fields, page }) => {
    const [isShowBanner, setIsShowBanner] = React.useState(!!false);
    let bgColor: any = {};
    switch (fields.bannerType) {
        case "alert":
            bgColor = "#AB1717";
          break;
        case "important":
            bgColor = COLORS.yellow;
          break;
        case "promotional":
            bgColor = COLORS.primaryBlue;
          break;
    }
    const alertStyle: InjectableCss = {
        css: css`
            width: 100%;
            min-height: 50px;
            position: sticky;
            color: #FFFFFF;
            background-color: ${bgColor};
            float: left;
            z-index: 11;
            p {
                font-size: 14px !important;
            }
        `,
    };
    const closeBtnHandler = () => {
        setIsShowBanner(true);
        if (window) {
            localStorage?.setItem("promotional-banner", "true");
        }
    }
    
    React.useEffect(() => {
        return () => {
            if (window) {
                localStorage?.setItem("promotional-banner", "");
            }
        }
    })
    if(isShowBanner || fields.content === "") {
        return null
    }
    return (
        <StyledWrapper {...alertStyle} id="alert-banner">
            <StyledWrapper {...styles.wrapper}>
                {parse(fields.content, parserOptions)}
            </StyledWrapper>
            <StyledWrapper {...styles.buttonWrapper} onClick={closeBtnHandler}>
                <svg focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </StyledWrapper>
        </StyledWrapper>
    )
}
const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(AlertBanner),
    definition: {
        group: "Common",
        icon: "list-ul",
        fieldDefinitions: [
            {
                name: fields.bannerType,
                editorTemplate: "DropDownField",
                defaultValue: "",
                fieldType: "General",
                options: [
                    {
                        value: "alert",
                        displayName: "Alert",
                    },
                    {
                        value: "important",
                        displayName: "Important",
                    },
                    {
                        value: "promotional",
                        displayName: "Promotional",
                    }
                ],
                hideEmptyOption: true,
                tab: basicTab,
            },
            {
                name: fields.content,
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
                validate: (html: string) => {
                    const arrayOfStyles = extractStylesToArray(html);
                    return arrayOfStyles?.every(style => isSafe(style))
                        ? null
                        : "The HTML contains invalid styles that prevent it from being saved";
                },
                tab: basicTab,
            }
        ],
    },
};

export default widgetModule;
